module.exports = __webpack_public_path__ + "bradavice_6_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_6_after.jpg
// module id = 939
// module chunks = 0